module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-9 col-md-9 col-xs-12 product-info"
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._t("description")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-529f75f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/product.vue
// module id = 263
// module chunks = 1